import React, {useEffect, useState} from 'react'
import {bookingService} from '../../../services/booking/bookingService'
import {dashboardService} from '../../../services/dashboardService'
import {BaseResponse} from '../../../types/base-response'
import {EmployeeDetailsResponse} from '../../../types/employee'
import LoadingIndicator from '../../../shared/UI/LoadingIndicator'
import {useBookingData} from './useBookingData'
import BookingNotification from  './BookingNotificationModal'
import {BookingCheckInOutPost} from '../../../services/booking/types'

function BookDesk() {
  const [employeeDetails, setEmployeeDetails] = useState<EmployeeDetailsResponse>()
  const [isLoading, setIsLoading] = useState(true)
  const [isBooked, setIsBooked] = useState(false)
  const [message, setMessage] = useState<string | null>(null)
  const bookingData = useBookingData(employeeDetails)
  const [showBookingNotificationModal, setBookingNotificationModal] = useState(false)
  const deskBookedSuccessfully = 'Desk booked successfully.'
  const deskAlreadyBooked = 'There is already a booking(s) for the request date and times.'

  useEffect(() => {
    dashboardService
      .getEmployeeDetails()
      .then((response) => {
        setEmployeeDetails(response)
      })
      .catch(error => {
        setMessage('Failed to load employee details.')
        console.error(error)
        setIsLoading(false)
      })
  }, [])

  useEffect(() => {
    if (!bookingData || !employeeDetails || !bookingData.employeeId || isBooked) return

    bookingService.createBooking(bookingData)
      .then((response) => {
        setIsBooked(true)
        setMessage(deskBookedSuccessfully)
          
        // Call checkInOut after successful booking
        
        const bookingId = (response as any).booking?.id
        
        const body: Partial<BookingCheckInOutPost> = {
          bookingID: bookingId!,
          userId: bookingData.employeeId!,
          type: 'in',
          actionDate: new Date().toISOString(),
          deskName: bookingData?.deskDetails?.deskName,
          anyIssues: '',
        }

        return bookingService.checkInOut(body)
      })
      .catch(error => {
        const response = error?.response?.data as BaseResponse
        if(response?.errors?.[0]?.description === deskAlreadyBooked){
          setMessage(deskBookedSuccessfully)
        }
        else{
          setMessage(response?.errors?.[0]?.description || 'Failed to book desk.')
        }
      })
      .finally(() => {
        setIsLoading(false)
        setBookingNotificationModal(true)
      })
  }, [bookingData, employeeDetails])

  const resetNotificationModal = () => {
    setBookingNotificationModal(false)
  }

  const handleRedirectClick = () => {
    window.location.replace(`/booking`)
  }

  return (
    <div className="book-desk-container">
      <LoadingIndicator show={isLoading} />

      {!isLoading && (
        <p className="redirect-message">
          <BookingNotification
            open={showBookingNotificationModal}
            titleText={message ?? ""}
            buttonLabel='Go to planner365'
            onClick={handleRedirectClick}
            message=''
            type="question"
            isDisabled={false}
            onClose={resetNotificationModal}
          />
        </p>
      )}
    </div>
  )
}

export default BookDesk
